import React from 'react';
import "./Home.css";
import { ScrollContext } from '../components/ScrollContext';
import { useState, useEffect, useRef, useContext } from 'react';
import background1 from '../images/General Presentation_page-0001.jpg';
import background2 from '../images/General Presentation_page-0002.jpg';
import background3 from '../images/General Presentation_page-0003.jpg';
import background4 from '../images/General Presentation_page-0004.jpg';
import background5 from '../images/General Presentation_page-0005.jpg';
import {motion} from 'framer-motion';

function Home(){


  // eslint-disable-next-line no-unused-vars
  const [isVisible, setIsVisible] = useState(false);
  const images = [
    background1,
    background2,
    background3,
    background4,
    background5
  ];
  const [slide1, setSlide1] = useState(true);
  const [slide2, setSlide2] = useState(false);
  const [slide3, setSlide3] = useState(false);
  const [slide4, setSlide4] = useState(false);
  const [slide5, setSlide5] = useState(false);

  const { setActiveSection } = useContext(ScrollContext);

  // Create refs for your sections
  const homeRef = useRef(null);
  const whoAreWeRef = useRef(null);
  const whyUsRef = useRef(null);

  document.addEventListener('scroll', function() {
    const parallaxIcon = document.querySelector('.scroll-parallax');

    if (!parallaxIcon) return;
    const scrollPosition = window.scrollY; // Get the current scroll position
    // const ideaIcon = document.querySelector('.idea-icon');

    // Adjust the top position based on the scroll position
    // The divisor (e.g., 2) controls the parallax effect strength
    parallaxIcon.style.top = `${scrollPosition * 0.5}px`; // Adjust this factor as needed
});

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.6, // Consider the section active when 60% is visible
    };

    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    const sections = [homeRef, whoAreWeRef, whyUsRef];
    sections.forEach(ref => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      sections.forEach(ref => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, [setActiveSection]);
  
  

  useEffect(() => {
    // After the component is mounted, set isVisible to true
    setIsVisible(true);

    // Cleanup function for when the component is about to unmount
    return () => {
      setIsVisible(false);
    };
  }, []);


  const dataText = `*MixNDraft info and brief details*`;
  
    return (
    <div> 
      
     <br/>
      <motion.div initial={{opacity:0 , transition: { duration: 0.1}}} animate={{opacity:100, transition: { duration: 0.5, delay:0 , ease: "easeInOut"}}} exit={{opacity:0, transition: { duration:0.5, ease: "easeInOut" }}} className={`container-fluid home-body`}>
  
        <div className='container-fluid'>
  
          <div className='row align-items-center justify-content-center description'> 
            <motion.div className="container-slides"
            initial={{opacity:0, transition: { duration: 0.1}}} 
            animate={{opacity:100, transition: { duration: 1.5, delay:0.7 , ease: "easeInOut"}}} 
            exit={{opacity:0, scale:1, transition: { duration: 0.4, ease: "easeInOut" }}}>
                <div className="parallax-image"></div>
                <section key={"home"} className="slide" id={"home"} ref={homeRef}>
                  <motion.img
                    src={background1}
                    alt={`Slide home`}
                    className="background-step"
                    initial={{ opacity: 0,x:"20vw" ,scale: 1 }}
                    whileInView={{
                      opacity: 1,
                      scale: 1,
                      x:"0",
                      transition: { duration: 1.3, delay: 0.1, ease: "backInOut" }
                    }}
                    exit={{x:"-30vw"}}
                    viewport={{ once: false, amount: 0.3 }}
                  />
                </section>
                <section key={"whoAreWe"} className="slide" id={"whoAreWe"} ref={whoAreWeRef}>
                  <motion.img
                    src={background2}
                    alt={`Slide whoAreWe`}
                    className="background-step"
                    initial={{ opacity: 0,x:"20vw" ,scale: 1 }}
                    whileInView={{
                      opacity: 1,
                      scale: 1,
                      x:"0",
                      transition: { duration: 1.3, delay: 0.1, ease: "backInOut" }
                    }}
                    exit={{x:"-30vw"}}
                    viewport={{ once: false, amount: 0.3 }}
                  />
                </section>
                <section key={"whyUs"} className="slide" id={"whyUs"} ref={whyUsRef}>
                <motion.img
                  src={background3}
                  alt={`Slide whyUs`}
                  className="background-step"
                  initial={{ opacity: 0,x:"20vw" ,scale: 1 }}
                  whileInView={{
                    opacity: 1,
                    scale: 1,
                    x:"0",
                    transition: { duration: 1.3, delay: 0.1, ease: "backInOut" }
                  }}
                  exit={{x:"-30vw"}}
                  viewport={{ once: false, amount: 0.3 }}
                />
              </section>
              <section key={"imageGallery"} className="slide" id={"imageGallery"}>
                <motion.img
                  src={background4}
                  alt={`Slide whyUs`}
                  className="background-step"
                  initial={{ opacity: 0,x:"20vw" ,scale: 1 }}
                  whileInView={{
                    opacity: 1,
                    scale: 1,
                    x:"0",
                    transition: { duration: 1.3, delay: 0.1, ease: "backInOut" }
                  }}
                  exit={{x:"-30vw"}}
                  viewport={{ once: false, amount: 0.3 }}
                />
              </section>
              {/* <section key={"thankYou"} className="slide" id={"thankYou"} >
                <motion.img
                  src={background5}
                  alt={`Slide whyUs`}
                  className="background-step"
                  initial={{ opacity: 0,x:"20vw" ,scale: 1 }}
                  whileInView={{
                    opacity: 1,
                    scale: 1,
                    x:"0",
                    transition: { duration: 1.3, delay: 0.1, ease: "backInOut" }
                  }}
                  exit={{x:"-30vw"}}
                  viewport={{ once: false, amount: 0.3 }}
                />
              </section> */}

            </motion.div>
          </div>
        </div>
      </motion.div>  


    </div>

    );
    
  }
export default Home;